import React from "react";
import { connect } from "react-redux";
import Box from "signoxe/components/layout/Box";
import Button from "signoxe/components/widgets/Button";
import { addQuizAsset, setPageTitle, setQuizStations } from "signoxe/actions";
import { API_ROOT } from "signoxe/constants/config";

class QuizAppPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      selected_quiz: "",
    };
  }

  componentDidMount() {
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.props.token}`,
      },
    };

    fetch(`${API_ROOT}quiz/`, requestOptions)
      .then((response) => {
        if (response.ok) {
          console.log("response", response)
          return response.json();
        }
      })
      .then((obj) => {
        if (obj) {
          console.log("quiz app", obj)
          this.props.setQuizStations(obj);
          console.log("quiz render props", this.props.stations)
        }
      });

    this.props.setPageTitle("Adding Quiz Asset");
  }

  render() {
    console.log("quiz render props", this.props.stations)

    return (
      <div className="asset-editing-page">
        <p>QUIZ APP ASSET</p>
        <input
          type="text"
          placeholder="Asset name"
          value={this.state.name}
          onChange={(event) => this.setState({ name: event.target.value })}
        />
        {this.props.stations.length > 0 ? (
          <select
            name="selected_quiz"
            onChange={(event) => this.changeSelectedStation(event.target.value)}
            value={this.state.selected_quiz.id}
          >
            <option value="">Please choose a quiz</option>
            {this.props.stations.map((station) => (
              <option key={`${station.id}`} value={station.id}>
                {station.name}
              </option>
            ))}
          </select>
        ) : (
          <p>Loading stations...</p>
        )}

        <Box
          direction="row"
          justifyContent="flex-end"
          className="actions button-group"
        >
          <Button
            primary
            onClick={this.saveEnabled() ? (event) => this.save() : null}
          >
            Save
          </Button>
          {/* <Button secondary onClick={event => this.props.disable()}>Cancel</Button> */}
        </Box>
      </div>
    );
  }

  changeSelectedStation(selected_quiz) {
    this.setState({ selected_quiz });
  }

  saveEnabled() {
    return this.state && this.state.name && this.state.selected_quiz;
  }

  cancel() {
    this.props.history.push("/assets");
  }

  save() {
    this.props.addQuizAsset({
      ...this.state,
      asset_url: JSON.stringify(this.state),
    });
    setTimeout(this.props.refresh, 700);
  }

  isNewAsset() {
    return this.props.match.params.id === undefined;
  }
}

const mapStateToProps = (state, ownProps) => {
  const quizStations = state.uiState.quizStations;
  return {
    stations: quizStations,
    token: state.authState.token,
    // asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle: (title) => dispatch(setPageTitle(title)),
    setQuizStations: (stations) => dispatch(setQuizStations(stations)),

    addQuizAsset: (data) => dispatch(addQuizAsset(data)),
    updateQuizAsset: (id, data) => dispatch(updateQuizAsset(id, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuizAppPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Quiz_App.js